import React, {useState} from 'react'
import {Tooltip} from "@mui/material";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ConfirmDialog from "../../../general/ConfirmDialog";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";


export default function HinUndRueckspielTauschenComp({spieltagId, onRefresh}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [showDialog, setShowDialog] = useState(false)

    const change = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.league + "/liga/spiel/heimrecht/hinundrueckspiel/change/" + spieltagId;
        FetchUtil.fetchPost(url,
            {},
            (message) => {
                if( message ) {
                    setErrorMessage(message);
                    setShowDialog(false);
                } else {
                    setInfoMessage("Speichern erfolgreich");
                    setShowDialog(false);
                    onRefresh();
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setShowDialog(false);
            });
    }

    return <>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <Tooltip title="Hin- und Rückspiel tauschen">
            <CompareArrowsIcon style={{marginRight: 10, cursor: "pointer"}} onClick={() => setShowDialog(true)}/>
        </Tooltip>
        {showDialog && <ConfirmDialog header="Hin- und Rückspiel tauschen"
                                       visible={true}
            callBackOnNein={() => setShowDialog(false)}
            callBackOnJa={() => change()}
                                       textOben={"Beim Tauschen wird die Uhrzeit des Spieles unverändert gelassen, bitte überprüfe ob der Spielzeitpunkt nach dem Tauschen richtig ist."}
                                       textUnten={"Möchtest du das Heimrecht am Hin- und Rückspiel wirklich tauschen?"}
            />}
    </>
}